'use client';

import { ToastContainer } from 'react-toastify';
import { useSearchParams, usePathname, useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { toast } from 'react-toastify';

/**
 * Custom hook to handle toast messages from search parameters
 * Displays success and error messages from URL query parameters
 * and removes them from the URL after displaying
 */
const useSearchParamsMessage = (): void => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const successMsg = searchParams.get('success');
    const errorMsg = searchParams.get('error');

    if (!successMsg && !errorMsg) return;

    if (successMsg) toast.success(successMsg);
    if (errorMsg) toast.error(errorMsg);

    const nextSearchParams = new URLSearchParams();
    searchParams.forEach((value, name) => {
      if (name === 'success' || name === 'error') return;
      nextSearchParams.append(name, value);
    });

    router.replace(`${pathname}?${nextSearchParams.toString()}`);
  }, [searchParams, router, pathname]);
};

/**
 * Toast provider component that handles displaying toast notifications
 * Automatically processes success/error messages from URL search parameters
 * @returns JSX.Element
 */
export default function ToastProvider() {
  useSearchParamsMessage();

  return (
    <ToastContainer
      theme="colored"
      position="top-center"
    />
  );
}